import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import type WritingLegendsTimeOnTaskRoute from 'teacher-ui-client/reporting/ui-scope/writing-legends/time-on-task/route'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingUiScopeSelect } from 'teacher-ui-client/components/reporting/ui-scope-select'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect, ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { TimeOnTaskUsageWL } from 'teacher-ui-client/components/reporting/writing-legends/time-on-task/usage'
import { TimeOnTaskHistory } from 'teacher-ui-client/components/reporting/writing-legends/time-on-task/history'
import { hasId } from 'teacher-ui-client/utils/type-guards'

interface Signature {
  Args: {
    model: ModelFor<WritingLegendsTimeOnTaskRoute>
  }
}

class WritingLegendsTimeOnTaskPage extends Component<Signature> {
  get statsScope(): StudentsScope {
    return { scope: 'students', ids: this.args.model.scopedStudents.filter(hasId).map((s) => s.id) }
  }

  get exportOptions() {
    return [{ exportType: ExportType.CSV }]
  }

  <template>
    <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.timeOnTaskUsage"}} />
    <ReportingControls>
      <ReportingUiScopeSelect class="shrink basis-80" />
      <ReportingControlsGap />
      <ReportingPeriodSelect />
      <ReportingControlsGap />
      <ReportingExportSelect @exportOptions={{this.exportOptions}} />
    </ReportingControls>

    <ContentTile>
      <TimeOnTaskUsageWL
        class="m-3"
        @noContentClass="m-4"
        @statsScope={{this.statsScope}}
        @period={{@model.period}}
        @uiScope={{@model.uiScope}}
      />
    </ContentTile>
    <ContentTile class="mt-4 print:border-none">
      <TimeOnTaskHistory
        @noContentClass="m-4"
        @statsScope={{this.statsScope}}
        @period={{@model.period}}
        @scopedStudents={{@model.scopedStudents}}
      />
    </ContentTile>
  </template>
}

export default RouteTemplate(WritingLegendsTimeOnTaskPage)
